module.exports = __webpack_public_path__ + "static/struff-red-28a15e383e7cb257b57e4c95042db898.png";